export const BRAND = {
  name: 'AgentPopulation',
  domain: 'agentpopulation.com',
  url: 'https://agentpopulation.com',
  title: 'AgentPopulation — How many machines share Earth?',
  description: 'A live observatory tracking the machine population alongside humanity — country by country. Every figure sourced, nothing faked.',
  corrections: 'corrections@agentpopulation.com',
};
